import { BuildBadge } from "./BuildBadge.js";
import "./HoldingScreen.css";

export function HoldingScreen(props: { message: string; detail?: string; children?: React.ReactNode }): React.JSX.Element {
  return (
    <div className="holding-screen">
      <div className="holding-screen__mark" aria-hidden="true" />
      <p className="holding-screen__message">{props.message}</p>
      {props.detail ? <p className="holding-screen__detail">{props.detail}</p> : null}
      {props.children}
      <BuildBadge />
    </div>
  );
}
